(() => {
  const reviewDateSelector =
    '#judgeme_product_reviews .jm-reviewer-info__details > .jm-cluster:last-child > .jm-text';
  const usDatePattern = /^(\d{2})\/(\d{2})\/(\d{4})$/;

  const formatReviewDate = (element) => {
    const match = element.textContent.trim().match(usDatePattern);

    if (!match) return;

    const [, month, day, year] = match;
    element.textContent = `${year}/${month}/${day}`;
  };

  const formatReviewDates = (root = document) => {
    if (root.nodeType === Node.ELEMENT_NODE && root.matches(reviewDateSelector)) {
      formatReviewDate(root);
    }

    root.querySelectorAll?.(reviewDateSelector).forEach(formatReviewDate);
  };

  const observer = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      if (mutation.type === 'characterData') {
        const element = mutation.target.parentElement;

        if (element?.matches(reviewDateSelector)) formatReviewDate(element);
        return;
      }

      mutation.addedNodes.forEach((node) => {
        if (node.nodeType === Node.ELEMENT_NODE) formatReviewDates(node);
      });
    });
  });

  formatReviewDates();
  observer.observe(document.body, {
    childList: true,
    subtree: true,
    characterData: true,
  });
})();
